import { useRef } from 'react';
import { useSetRecoilState } from 'recoil';
import { videoProgressState } from '../recoil/atoms';

export default function useVideoProgression() {
    const currentVideoDurationRef = useRef<number>();
    const setVideoProgress = useSetRecoilState(videoProgressState);

    const handleSetVideoProgression = (playedSeconds: number) => {
        if (currentVideoDurationRef.current) {
            const timeLeftSeconds = Math.round(currentVideoDurationRef.current - playedSeconds);

            setVideoProgress({ playedSeconds, timeLeftSeconds });
        }
    };

    const handleSetVideoDuration = (duration: number) => {
        currentVideoDurationRef.current = duration;
    };

    return { registerDuration: handleSetVideoDuration, registerVideoProgress: handleSetVideoProgression };
}
